

document.addEventListener("DOMContentLoaded", function () {

  function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
}

  const trackingInput = document.getElementById("shiptrack-track-input");
  const trackButton = document.getElementById("shiptrack-track-submit");

  trackButton.addEventListener("click", function (event) {
    event.preventDefault();

    const trackingValue = trackingInput.value;

    const url = `https://portal.shiptrackapp.com/view.aspx?tracking=${trackingValue}`;

    // Open the link in a new window
    window.open(url, '_blank');
  });

});